export default __webpack_public_path__ + "static/media/turbilhao-de-dados.6e58f8dc.png";